import { useParams } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
//import PersonaDetails from './details'
import { Component } from 'react'
import ProfileHeader from '../../../modules/profile/ProfileHeader'

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class DetallesPagina extends Component {
  render() {
    return (
      <>
        <PageTitle>Detalles</PageTitle>
        <ProfileHeader id={this.props.params.id} tipo='persona' />
      </>
    )
  }
}

export default withParams(DetallesPagina)
